import React from 'react';
import { Messages1, TextalignJustifycenter } from 'iconsax-react';
import { Layout } from 'antd';
import { useNavigate } from 'react-router-dom';

import UserDropdown from './UserDropdown.tsx';

const { Header } = Layout;

interface HeaderProps {
  collapsed: boolean;
  onCollapse: (collapsed: boolean) => void;
}

export const HeaderLayout = ({ collapsed, onCollapse }: HeaderProps) => {
  const navigate = useNavigate();

  return (
    <Header className="bg-white p-6 w-full flex justify-between items-center">
      <button
        onClick={() => {
          onCollapse(!collapsed);
        }}
        className=" flex h-9 w-9 text-black"
      >
        <TextalignJustifycenter size="32" />
      </button>

      <div className='flex items-center gap-3'>
        <div className="cursor-pointer">
          <Messages1 size="24" variant='Bold' onClick={() => navigate('/messages')} />
        </div>
        <UserDropdown />
      </div>
    </Header>
  );
};
